import { CopyBranding } from './Copy'

export const CopyClipsal: CopyBranding = {
  PictogramsDescription: null,
  ProSeriesRangeDisplayName: 'Clipsal Pro',
}